export const CATEGORIES = [
  {
    slug: "stroje-tezka-technika",
    name: "Stroje a těžká technika",
    heroLabel: "Stroje · technika",
    icon: "Truck",
    subcategories: [
      { slug: "bagry", name: "Bagry" },
      { slug: "rypadla", name: "Rypadla" },
      { slug: "nakladace", name: "Nakladače" },
      { slug: "brouseni-hoblovani", name: "Broušení a hoblování" },
      { slug: "zvedaci-plosiny", name: "Zvedací plošiny" },
      { slug: "traktorbagry", name: "Traktorbagry" },
      { slug: "hutnici-stroje", name: "Hutnící stroje" },
      { slug: "malotraktory", name: "Malotraktory" },
      { slug: "vysokozdvizne-voziky", name: "Vysokozdvižné vozíky" },
      { slug: "nakladni-automobily", name: "Nákladní automobily" },
      { slug: "jeraby", name: "Jeřáby" },
      { slug: "zemedelska-technika", name: "Zemědělská technika" },
      { slug: "drticky-tridicky", name: "Drtičky, třídičky" },
      { slug: "vytahy-vratky", name: "Výtahy, vrátky" },
      { slug: "snezna-technika", name: "Sněžná technika" },
      { slug: "ostatni-stroje", name: "Ostatní" },
    ],
  },
  {
    slug: "naradi-vybaveni",
    name: "Nářadí a vybavení",
    icon: "Wrench",
    subcategories: [
      { slug: "elektricke-aku-naradi", name: "Elektrické a AKU nářadí" },
      { slug: "rucni-naradi", name: "Ruční nářadí" },
      { slug: "merici-technika", name: "Měřící technika" },
      { slug: "elektrocentraly", name: "Elektrocentrály" },
      { slug: "michacky", name: "Míchačky" },
      { slug: "vysavace-kompresory", name: "Vysavače, kompresory" },
      { slug: "topidla-vysousece", name: "Topidla, vysoušeče" },
      { slug: "drevoobrabeci-stroje", name: "Dřevoobráběcí stroje" },
      { slug: "pily", name: "Pily" },
      { slug: "omitacky", name: "Omítačky" },
      { slug: "cerpadla", name: "Čerpadla" },
      { slug: "svarecky", name: "Svářečky" },
      { slug: "cistici-technika", name: "Čistící technika" },
      { slug: "zarizeni-staveniste", name: "Zařízení staveniště" },
      { slug: "vycepni-zarizeni", name: "Výčepní zařízení" },
      { slug: "ostatni-naradi", name: "Ostatní" },
    ],
  },
  {
    slug: "zarizeni-interieru",
    name: "Zařízení interiérů",
    icon: "Sofa",
    subcategories: [
      { slug: "stoly-zidle", name: "Stoly, židle" },
      { slug: "skrine", name: "Skříně" },
      { slug: "postele", name: "Postele" },
      { slug: "pohovky", name: "Pohovky" },
      { slug: "kuchyne", name: "Kuchyně" },
      { slug: "sanitarni-zarizeni", name: "Sanitární zařízení" },
      { slug: "varne-desky", name: "Varné desky" },
      { slug: "trouby", name: "Trouby" },
      { slug: "konvektomaty", name: "Konvektomaty" },
      { slug: "varne-konvice", name: "Varné konvice" },
      { slug: "fritezy", name: "Fritézy" },
      { slug: "kavovary", name: "Kávovary" },
      { slug: "mixery", name: "Mixéry" },
      { slug: "kvetiny", name: "Květiny" },
      { slug: "zaclony-garnyze", name: "Záclony, garnýže" },
      { slug: "nadobi", name: "Nádobí" },
      { slug: "interierove-dvere", name: "Interiérové dveře" },
      { slug: "lampicky", name: "Lampičky" },
      { slug: "ozvuceni", name: "Ozvučení" },
      { slug: "bila-technika", name: "Bílá technika" },
      { slug: "chytra-domacnost", name: "Chytrá domácnost" },
      { slug: "police", name: "Police" },
      { slug: "ostatni-interier", name: "Ostatní" },
    ],
  },
  {
    slug: "stavebni-material",
    name: "Stavební materiály",
    icon: "Package",
    subcategories: [
      { slug: "hruba-stavba", name: "Hrubá stavba" },
      { slug: "stavebni-desky", name: "Stavební desky" },
      { slug: "drevomaterialy", name: "Dřevomateriály" },
      { slug: "suche-smesi-chemie", name: "Suché směsi, stavební chemie" },
      { slug: "sypke-materialy-sterk", name: "Sypké materiály, štěrk" },
      { slug: "dlazby-obklady-mat", name: "Dlažby, obklady" },
      { slug: "barvy-laky", name: "Barvy, laky" },
      { slug: "tepelne-izolace", name: "Tepelné izolace" },
      { slug: "hydroizolace", name: "Hydroizolace" },
      { slug: "klempirske-prvky", name: "Klempířské prvky" },
      { slug: "hutni-materialy", name: "Hutní materiály" },
      { slug: "fasadni-systemy", name: "Fasádní systémy" },
      { slug: "sterkove-sparovaci-hmoty", name: "Stěrkové a spárovací hmoty" },
      { slug: "polykarbonatove-desky", name: "Polykarbonátové desky" },
      { slug: "kaminkove-povrchy", name: "Kamínkové povrchy" },
      { slug: "ostatni-material", name: "Ostatní" },
    ],
  },
  {
    slug: "casti-stavby",
    name: "Části stavby",
    icon: "Blocks",
    subcategories: [
      { slug: "elektromaterialy", name: "Elektromateriály" },
      { slug: "voda", name: "Voda" },
      { slug: "plyn", name: "Plyn" },
      { slug: "okna-dvere", name: "Okna-dveře" },
      { slug: "podlahy-krytiny", name: "Podlahy a krytiny" },
      { slug: "strechy-krytiny", name: "Střechy, krytiny" },
      { slug: "vytapeni", name: "Vytápění" },
      { slug: "zdroje-vytapeni", name: "Zdroje vytápění" },
      { slug: "ohrev-vody", name: "Ohřev vody" },
      { slug: "fotovoltaika", name: "Fotovoltaika" },
      { slug: "vzduchotechnika", name: "Vzduchotechnika" },
      { slug: "kominove-systemy", name: "Komínové systémy" },
      { slug: "klimatizace-tc", name: "Klimatizace, tepelná čerpadla" },
      { slug: "rekuperace", name: "Rekuperace" },
      { slug: "stresni-okna", name: "Střešní okna" },
      { slug: "obrubniky", name: "Obrubníky" },
      { slug: "ostatni-casti", name: "Ostatní" },
    ],
  },
  {
    slug: "konstrukce-leseni-bedneni",
    name: "Konstrukce, lešení, bednění",
    heroLabel: "Konstrukce, lešení, bednění",
    icon: "LayoutGrid",
    subcategories: [
      { slug: "bedneni", name: "Bednění" },
      { slug: "leseni", name: "Lešení" },
      { slug: "stropni-konstrukce", name: "Stropní konstrukce" },
      { slug: "kari-site", name: "Kari sítě" },
      { slug: "ocelove-konstrukce", name: "Ocelové konstrukce" },
      { slug: "drevene-konstrukce", name: "Dřevěné konstrukce" },
      { slug: "vzpery", name: "Vzpěry" },
      { slug: "armovaci-materialy", name: "Armovací materiály" },
      { slug: "ostatni-konstrukce", name: "Ostatní" },
    ],
  },
  {
    slug: "zahrada-exterier",
    name: "Zahrada a exteriér",
    icon: "Trees",
    subcategories: [
      { slug: "substraty", name: "Substráty" },
      { slug: "dekorace", name: "Dekorace" },
      { slug: "skladane-ploty", name: "Skládané ploty" },
      { slug: "prkenne-terasy", name: "Prkenné terasy" },
      { slug: "zdene-ploty", name: "Zděné ploty" },
      { slug: "bazeny", name: "Bazény" },
      { slug: "sauny", name: "Sauny" },
      { slug: "kvetinace-truhliky", name: "Květináče a truhlíky" },
      { slug: "zahradni-domky", name: "Zahradní domky" },
      { slug: "ploty-ostatni", name: "Ploty ostatní" },
      { slug: "sterk-kacirek", name: "Štěrk, kačírek" },
      { slug: "systemy-pergol", name: "Systémy pergol" },
      { slug: "venkovni-dlazby", name: "Venkovní dlažby" },
      { slug: "travniky", name: "Trávníky" },
      { slug: "rostliny", name: "Rostliny" },
      { slug: "povrchy-sportoviste", name: "Povrchy pro sportoviště" },
      { slug: "zahradni-nabytek", name: "Zahradní nábytek" },
      { slug: "zahradni-technika", name: "Zahradní technika" },
      { slug: "kultivatory", name: "Kultivátory" },
      { slug: "zahradni-osvetleni", name: "Zahradní osvětlení" },
      { slug: "jezirka", name: "Jezírka" },
    ],
  },
  {
    slug: "pujcovna",
    name: "Půjčovna",
    icon: "Key",
    subcategories: [
      { slug: "pj-auta-dodavky", name: "Auta, dodávky" },
      { slug: "pj-zahradni-technika", name: "Zahradní technika" },
      { slug: "pj-bagry", name: "Bagry" },
      { slug: "pj-rypadla", name: "Rypadla" },
      { slug: "pj-nakladace", name: "Nakladače" },
      { slug: "pj-brouseni-hoblovani", name: "Broušení a hoblování" },
      { slug: "pj-zvedaci-plosiny", name: "Zvedací plošiny" },
      { slug: "pj-traktorbagry", name: "Traktorbagry" },
      { slug: "pj-hutnici-stroje", name: "Hutnící stroje" },
      { slug: "pj-malotraktory", name: "Malotraktory" },
      { slug: "pj-leseni-bedneni", name: "Lešení, bednění" },
      { slug: "pj-vysokozdvizne-voziky", name: "Vysokozdvižné vozíky" },
      { slug: "pj-nakladni-automobily", name: "Nákladní automobily" },
      { slug: "pj-jeraby", name: "Jeřáby" },
      { slug: "pj-zemedelska-technika", name: "Zemědělská technika" },
      { slug: "pj-drticky-tridicky", name: "Drtičky, třídičky" },
      { slug: "pj-vytahy-vratky", name: "Výtahy, vrátky" },
      { slug: "pj-snezna-technika", name: "Sněžná technika" },
      { slug: "pj-vycepni-zarizeni", name: "Výčepní zařízení" },
      { slug: "pj-party-vybaveni", name: "Párty vybavení" },
      { slug: "pj-elektricke-aku-naradi", name: "Elektrické a AKU nářadí" },
      { slug: "pj-rucni-naradi", name: "Ruční nářadí" },
      { slug: "pj-merici-technika", name: "Měřící technika" },
      { slug: "pj-elektrocentraly", name: "Elektrocentrály" },
      { slug: "pj-michacky", name: "Míchačky" },
      { slug: "pj-vysavace-kompresory", name: "Vysavače, kompresory" },
      { slug: "pj-topidla-vysousece", name: "Topidla, vysoušeče" },
      { slug: "pj-drevoobrabeci-stroje", name: "Dřevoobráběcí stroje" },
      { slug: "pj-pily", name: "Pily" },
      { slug: "pj-omitacky", name: "Omítačky" },
      { slug: "pj-cerpadla", name: "Čerpadla" },
      { slug: "pj-svarecky", name: "Svářečky" },
      { slug: "pj-cistici-technika", name: "Čistící technika" },
      { slug: "pj-zarizeni-staveniste", name: "Zařízení staveniště" },
      { slug: "pj-ostatni", name: "Ostatní" },
    ],
  },
];

export const SUBCATEGORY_NAMES = CATEGORIES.reduce((acc, c) => {
  c.subcategories.forEach((sc) => (acc[sc.slug] = sc.name));
  return acc;
}, {});

export const CATEGORY_NAMES = CATEGORIES.reduce((acc, c) => {
  acc[c.slug] = c.name;
  return acc;
}, {});

export function findCategory(slug) {
  return CATEGORIES.find((c) => c.slug === slug);
}

export function formatPriceCzk(value, negotiable) {
  if (value == null || value === "") return negotiable ? "Dohodou" : "Zdarma";
  try {
    const n = Number(value);
    if (!Number.isFinite(n)) return "Dohodou";
    return `${n.toLocaleString("cs-CZ")} Kč`;
  } catch (_) {
    return "Dohodou";
  }
}

export function formatDateCzk(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("cs-CZ", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    });
  } catch (_) {
    return "";
  }
}
